import React, {useEffect, useState} from 'react';
import { Route, Switch, Redirect } from 'react-router';
import {useParams} from "react-router-dom";
import * as R from 'ramda';

import { Help } from './../_common/help';
import { Path } from './../_common/path';

import { DossierLoading } from './loading';
import { DossierDashboard } from './dashboard';
import { DashboardAnticipa } from './dashboard-anticipa';
import { DossierProfile } from './profile';
import { DossierReferents } from './referents';
import { DossierComunes } from './comunes';
import { DossierPersonal } from './personal';
import { DossierBiblioteque } from './biblioteque';

import { useSelector, useDispatch } from 'react-redux';
import { getDeathDeclaration, getDocuments, getLettersForUserId, getUserConnections, getUserServiceData, getUserRepresentativesForUserId, getUserInfoById } from './../../../actions/facilita-api';


export const Dossier = ({isDemo}) => {

	const dispatch = useDispatch();
	const router = useSelector(state => state.router);
	const facilitaState = useSelector(state => state.facilita);
	const deathDeclarationState = useSelector(state => state.deathDeclaration);

	let { userId } = useParams();
	let deceasedUser = facilitaState.representing.find(r => r.id === userId);

	useEffect(() => {
        if (!R.isNil(deceasedUser)) {
            dispatch(getDeathDeclaration(deceasedUser.id, deceasedUser)).
			then((resp) => {
				if(resp === "NotFound"){
					dispatch(getUserInfoById(deceasedUser.id));
				}
			});
			dispatch(getDocuments(deceasedUser.id));
			dispatch(getLettersForUserId(deceasedUser.id));
			dispatch(getUserConnections(deceasedUser.id));
			dispatch(getUserServiceData(deceasedUser.id, undefined));
			dispatch(getUserRepresentativesForUserId(deceasedUser.id));

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deceasedUser]);

	const deathDate = R.isNil(deathDeclarationState.declaration) ? undefined : deathDeclarationState.declaration.deathDate;
	if(R.isNil(deathDeclarationState.declaration)){
		return "";
	}
	return (
		<>
		<div className='container-fluid flex-md-row align-items-center gap-xs pt-3'>
			<Help row={true} />
			<Path deceasedUser={deceasedUser} declaration={deathDeclarationState.declaration} serviceDatas={deathDeclarationState.serviceDatas} userLetters={deathDeclarationState.userLetters} />							
		</div>
		<Switch>
			<Route exact path="/facilita/:userId">
				{
					R.isNil(deathDeclarationState.user) ?
					<DossierDashboard serviceDatas={deathDeclarationState.serviceDatas} userLetters={deathDeclarationState.userLetters} files={deathDeclarationState.files} userId={userId} deathDate={deathDate} isLoading={deathDeclarationState.isLoading} connectionTypes={deathDeclarationState.connectionTypes} declaringUserId={deathDeclarationState.declaration.declaringUserId} currentlyConnectedUserId={facilitaState.user.id} deceasedUser={deceasedUser} generateLetters={R.isNil(deathDeclarationState.user)} />
					:
						<DashboardAnticipa userId={userId} user={deathDeclarationState.user} serviceDatas={deathDeclarationState.serviceDatas} isLoading={deathDeclarationState.isLoading} connectionTypes={deathDeclarationState.connectionTypes} />

				}

			</Route>
			<Route path="/facilita/:userId/profile">
				<DossierProfile userId={userId} userInfo={deathDeclarationState.declaration} isLoading={deathDeclarationState.isLoading} />
			</Route>
			<Route path="/facilita/:userId/referent">
				<DossierReferents referents={deathDeclarationState.referents} userId={userId} isLoading={deathDeclarationState.isLoading} />
			</Route>
			<Route path="/facilita/:userId/loading">
				<DossierLoading userId={userId} isLoading={deathDeclarationState.isLoading} />
			</Route>
			<Route path="/facilita/:userId/communes" >
				<DossierComunes connectionTypes={deathDeclarationState.connectionTypes} userId={userId} user={deathDeclarationState.user} serviceDatas={deathDeclarationState.serviceDatas} isLoading={deathDeclarationState.isLoading} generateLetters={R.isNil(deathDeclarationState.user)} />
			</Route>
			<Route path="/facilita/:userId/personal" >
				<DossierPersonal connectionTypes={deathDeclarationState.connectionTypes} userId={userId} user={deathDeclarationState.user} serviceDatas={deathDeclarationState.serviceDatas} isLoading={deathDeclarationState.isLoading} generateLetters={R.isNil(deathDeclarationState.user)} isDemo={isDemo} />
			</Route>
			<Route path="/facilita/:userId/biblioteque">
				<DossierBiblioteque userId={userId} files={deathDeclarationState.files} userRepresentativeId={facilitaState.user.id} isLoading={deathDeclarationState.isLoading} />
			</Route>
			<Route render={() => {
				return <Redirect exact to="/facilita/:userId" />
			}} />
		</Switch>
		</>
	)
}